module.exports = __webpack_public_path__ + "img/ChartPie.2ba3ad86.jpg";